import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { RUNTIME_CONFIG } from '@safra-frontend/core';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

fetchSettings().then((config) => {
  platformBrowserDynamic([{ provide: RUNTIME_CONFIG, useValue: config }])
    .bootstrapModule(AppModule)
    .catch((err) => console.error('Falha crítica durante o bootstraping da aplicação', err));
});

export function fetchSettings(): any {
  return new Promise((resolve, reject) => {
    const url = 'assets/config/appSettings.json';

    const xhr = new XMLHttpRequest();
    xhr.onload = (e) => {
      if (Number(xhr.status) === 200) {
        resolve(JSON.parse(xhr.response));
      } else {
        resolve(undefined);
      }
    };
    xhr.onerror = () => {
      resolve(undefined);
    };
    xhr.open('GET', url);
    xhr.send(null);
  });
}

const geneseConfig = {
  projectName: 'nome-do-projeto',
  projectAcronym: 'sigla',
  projectEnvironment: 'PROD', //ambiente
  projectUUID: 'ae984d57-450f-4e3c-80db-a68a664f6dc4',
};

localStorage.setItem('geneseConfig', JSON.stringify(geneseConfig));
